export default __webpack_public_path__ + "static/media/text_center_selected.010a5578.svg";